import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxsModule } from '@ngxs/store';
import { CustomMaterialModule } from 'app/custom-material/custom-material.module';
import { ChartsModule, ThemeService } from 'ng2-charts';
import { Ng5SliderModule } from 'ng5-slider';
import { GuidedTourModule } from 'ngx-guided-tour';
import { CoreModule } from '../core/core.module';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ExploreComponent } from './components/explore/explore.component';
import { PftCftScoresComponent } from './components/pft-cft-scores/pft-cft-scores.component';
import { FitnessSurveyChartComponent } from './components/total-fitness-survey/fitness-survey-chart/fitness-survey-chart.component';
import { TotalFitnessSurveyComponent } from './components/total-fitness-survey/total-fitness-survey.component';
import { TrainingLoadChartComponent } from './components/training-load-chart/training-load-chart.component';
import { ExploreRoutingModule } from './explore-routing.module';
import { ExploreState } from './state/explore.state';


@NgModule({
  providers: [ThemeService],
  declarations: [
    ExploreComponent,
    TrainingLoadChartComponent,
    DashboardComponent,
    TotalFitnessSurveyComponent,
    FitnessSurveyChartComponent,
    PftCftScoresComponent
  ],
  imports: [
    CommonModule,
    ExploreRoutingModule,
    NgxsModule.forFeature([ExploreState]),
    CustomMaterialModule,
    ScrollingModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    Ng5SliderModule,
    CoreModule,
    ChartsModule,
    GuidedTourModule
  ]
})
export class ExploreModule { }
